module.exports = __webpack_public_path__ + "img/heart.0dfeae41.svg";